import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { DataTablesResponse } from '../models/datatables';
import { ChatbotDocumentDTO, ChatbotDocumentUpdateFileDTO } from '../models/chatbot-document-dto';
import { Select2Data } from 'ng-select2-component';

@Injectable({
  providedIn: 'root'
})

export class ChatbotDocumentService {

  private pathAPI = environment.urlAPI;
  private controller = "ChatbotDocument/";

  constructor(private http: HttpClient) { }

  public get(id: string): Observable<ChatbotDocumentDTO> {
    return this.http.get<ChatbotDocumentDTO>(this.pathAPI + this.controller + id);
  }

  public post(data: ChatbotDocumentDTO): Observable<ChatbotDocumentDTO> {
    return this.http.post<ChatbotDocumentDTO>(this.pathAPI + this.controller, data);
  }

  public put(id: string, data: ChatbotDocumentDTO): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + id, data);
  }

  public changeStatus(id: string, idStatus: number): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + 'ChangeStatus/' + id + '/' + idStatus, null);
  }

  public changeIndexable(id: string, indexable: boolean): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + 'ChangeIndexable/' + id + '/' + indexable, null);
  }

  public changeReturnDocumentAsReference(id: string, returnDocumentAsReference: boolean): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + 'ChangeReturnDocumentAsReference/' + id + '/' + returnDocumentAsReference, null);
  }

  public updateFile(id: string, data: ChatbotDocumentUpdateFileDTO): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + 'UpdateFile/' + id, data);
  }

  public updateFileIa(id: string, data: ChatbotDocumentUpdateFileDTO): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + 'UpdateFileIa/' + id, data);
  }

  public deleteFile(id: string): Observable<any> {
    return this.http.delete<any>(this.pathAPI + this.controller + 'DeleteFile/' + id);
  }

  public deleteFileIa(id: string): Observable<any> {
    return this.http.delete<any>(this.pathAPI + this.controller + 'DeleteFileIa/' + id);
  }
    
  public getDataTable(data: any, filters: string): Observable<DataTablesResponse> {
    return this.http.post<DataTablesResponse>(this.pathAPI + this.controller + 'GetDataTable/' + filters, data);
  } 

}
